import { all } from "redux-saga/effects";
import getFileTimelineCRM from "./getFileTimelineCRM";
import postConfirmTimelineCRMApi from "./postConfirmTimelineCRMApi";
import postSigntureApi from "./postSigntureApi";

export const signaturePageSaga = function* root() {
	yield all([
		getFileTimelineCRM(),
		postConfirmTimelineCRMApi(),
		postSigntureApi()
	]);
};
